export const MODULES = {
  USERS: 1001,
  HARDWARE_STORES: 1002,
  REFERENCES: 1003,
  PROFILES: 1004,
  RULES_INVOICE: 1005,
  RULES_PRODUCT: 1006,
  RULES_REGISTER: 1007,
  RULES_REGISTER_REFERRED: 1008,
  RULES_WELCOME: 1009,
  MESSAGES: 1010,
  SEGMENTATION: 1011,
  INVOICES: 1012,
  REDEMPTIONS: 1013,
  BONUSES: 1014,
  REPORTS: 1015,
  CUSTOMERS: 1016,
  VALIDATIONS: 1017,
  REFERRED: 1018,
  CRM: 1019,
  CRM_RULES: 1020,
  CRM_SOURCES: 1021,
  PAYMENT_CATEGORIES: 1022,
  PAYMENT_PACKAGES: 1023,
  LOGS: 1024,
  CONFIGURATION: 1025,
} as const;

export const ACTIONS = {
  USERS: {
    LIST: 1001001,
    CREATE: 1001002,
    EDIT: 1001003,
    DELETE: 1001004,
    CHANGE_PASSWORD: 1001005,
    DETAIL: 1001006,
  },
  HARDWARE_STORES: {
    LIST: 1002001,
    CREATE: 1002002,
    EDIT: 1002003,
    DELETE: 1002004,
  },
  REFERENCES: {
    LIST: 1003001,
    CREATE: 1003002,
    EDIT: 1003003,
    DELETE: 1003004,
  },
  PROFILES: {
    LIST: 1004001,
    CREATE: 1004002,
    EDIT: 1004003,
    DELETE: 1004004,
  },
  RULES_INVOICE: {
    LIST: 1005001,
    CREATE: 1005002,
    EDIT: 1005003,
    DELETE: 1005004,
  },
  RULES_PRODUCT: {
    LIST: 1006001,
    CREATE: 1006002,
    EDIT: 1006003,
    DELETE: 1006004,
    DETAIL: 1006005,
  },
  RULES_REGISTER: {
    LIST: 1007001,
    CREATE: 1007002,
    EDIT: 1007003,
    DELETE: 1007004,
  },
  RULES_REGISTER_REFERRED: {
    LIST: 1008001,
    CREATE: 1008002,
    EDIT: 1008003,
    DELETE: 1008004,
  },
  RULES_WELCOME: {
    LIST: 1009001,
    CREATE: 1009002,
    EDIT: 1009003,
    DELETE: 1009004,
  },
  MESSAGES: {
    LIST: 1010001,
    CREATE: 1010002,
    EDIT: 1010003,
    DELETE: 1010004,
  },
  SEGMENTATION: {
    CHANGE: 1011001,
  },
  INVOICES: {
    LIST: 1012001,
    CREATE: 1012002,
    EDIT: 1012003,
    DELETE: 1012004,
    EXPORT: 1012005,
    DETAIL: 1012006,
  },
  REDEMPTIONS: {
    LIST: 1013001,
    CREATE: 1013002,
    EDIT: 1013003,
    DELETE: 1013004,
    EXPORT: 1013005,
    DETAIL: 1013006,
  },
  BONUSES: {
    LIST: 1014001,
    CREATE: 1014002,
    EDIT: 1014003,
    DELETE: 1014004,
  },
  REPORTS: {
    LIST: 1015001,
    EXPORT: 1015002,
    DETAIL: 1015003,
    DELETE: 1015004,
  },
  CUSTOMERS: {
    LIST: 1016001,
    CREATE: 1016002,
    EDIT: 1016003,
    BLOCK: 1016004,
    DETAIL: 1016005,
    EXPORT: 1016006,
  },
  VALIDATIONS: {
    LIST: 1017001,
    CREATE: 1017002,
    EDIT: 1017003,
    CREATE_REDEMPTION: 1017004,
  },
  REFERRED: {
    LIST: 1018001,
    CREATE: 1018002,
    EDIT: 1018003,
    DELETE: 1018004,
    EXPORT: 1018005,
  },
  CRM: {
    LIST: 1019001,
    CREATE: 1019002,
    EDIT: 1019003,
    DELETE: 1019004,
    DETAIL: 1019005,
    EXPORT: 1019006,
  },
  CRM_RULES: {
    LIST: 1020001,
    CREATE: 1020002,
    EDIT: 1020003,
    DELETE: 1020004,
  },
  CRM_SOURCES: {
    LIST: 1021001,
    CREATE: 1021002,
    EDIT: 1021003,
    DELETE: 1021004,
  },
  PAYMENT_CATEGORIES: {
    LIST: 1022001,
    CREATE: 1022002,
    EDIT: 1022003,
    DELETE: 1022004,
    DETAIL: 1022005,
  },
  PAYMENT_PACKAGES: {
    LIST: 1023001,
    CREATE: 1023002,
    EDIT: 1023003,
    DELETE: 1023004,
  },
  LOGS: {
    LIST: 1024001,
    DELETE: 1024004,
  },
  CONFIGURATION: {
    LIST: 1025001,
    EDIT: 1025003,
    // Ejecutar manualmente el job de vencimiento de saldos. Solo superadministrador (ver API PermissionActions)
    RUN_JOBS: 1025005,
  },
} as const;

export const ALL_ACTION_IDS = Object.values(ACTIONS).flatMap(actions => Object.values(actions));
export const ALL_MODULE_IDS = Object.values(MODULES);
